<div class="flex h-screen w-screen">
  <!-- <p class="dark:text-white">sign-in works!</p> -->
  <!-- <app-dark-mode></app-dark-mode> -->
   <div class="flex w-[60%] justify-center items-center relative">
    <div class="">
      <img [src]="images.landscape" alt="landscape" class="w-screen p-32" />
    </div>
    <label class="font-normal text-xs neutrals-grey-03-text absolute bottom-0 right-0 p-2">Image designed by Freepik from Storyset</label>
  </div>
  <div class="flex flex-col p-[60px] w-[40%] h-full justify-center items-center neutrals-grey-01-background">
    <img [src]="images.logos.backofficeLogo" alt="logo" class="rounded-[32px]" />
    @if (ephemeralToken === '' && !expiredPassword) {
      <label class="font-bold text-[40px] mt-5">BackOffice</label>
      <form #form novalidate (ngSubmit)="onSubmit()">
        <div class="relative mb-4 mt-5">
          <div class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
            <img id="username" [src]="images.login.username" class="w-6" />
          </div>
          <input type="text" id="usr" alt="user" [placeholder]="literalService.get('login.username', true)" [(ngModel)]="username" [ngModelOptions]="{standalone: true}" class="block pl-12 w-96 h-12 px-3 py-2 bg-white border rounded-s rounded-e text-sm placeholder-slate-400 focus:outline-none" />
        </div>
        <div class="relative mb-6">
          <div class="absolute z-10 inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
            <img id="password" [src]="images.login.password" class="w-6" />
          </div>
          <app-input-password [id]="'password'" class="w-6" [placeholder]="literalService.get('login.password', true)" (changeEventEmitter)="setPassword($event)" [hasIcon]="true" required />
        </div>
        <button type="submit" [disabled]="doingLogin" class="primary cursor-pointer text-white font-semibold uppercase w-96 h-14">
          @if (doingLogin) {
            <ng-lottie [options]="loadingLogin" (animationCreated)="utilsService.animationCreated($event, 1.5)" />
          } @else {
            {{ literalService.get('login.login', true) }}
          }
        </button>
      </form>
    } @else if (expiredPassword) {
      <div class="flex flex-col">
        <label class="font-bold text-[40px] text-center mt-5">{{ literalService.get('login.expiredPassword.title', true) }}</label>
        <label class="font-normal text-[16px] neutrals-grey-05-text text-center mt-[16px]" [innerHTML]="literalService.get('login.expiredPassword.text', true)"></label>
      </div>
      <form #form novalidate (ngSubmit)="timer === TIME_FINISHED ? onSubmit() : resetPassword()">
        <div class="relative mb-4 mt-[40px]">
          <div class="absolute z-10 inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
            <img id="password" alt="password" [src]="images.login.password" [ngClass]="{'disabled': timer === TIME_FINISHED}" class="w-6" />
          </div>
          <app-input-password [id]="'newPassword'" [value]="newPassword" class="w-6" [placeholder]="literalService.get('login.expiredPassword.password', true)" [hasIcon]="true" [disabled]="timer === TIME_FINISHED" [hasErrors]="errorExpiredPassword" (keyup)="setNewPassword($event.target); checkPasswordLength()" required />
        </div>
        <div class="relative">
          <div class="absolute z-10 inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
            <img id="confirmPassword" alt="confirmPassword" [src]="images.login.password" [ngClass]="{'disabled': timer === TIME_FINISHED}" class="w-6" />
          </div>
          <app-input-password [id]="'confirmPassword'" [value]="confirmPassword" class="w-6" [placeholder]="literalService.get('login.expiredPassword.confirmPassword', true)" [hasIcon]="true" [disabled]="timer === TIME_FINISHED" [hasErrors]="errorExpiredPassword" (keyup)="setConfirmPassword($event.target); checkPasswordLength()" required />
        </div>
        @if (timer === TIME_FINISHED) {
          <div class="flex justify-end">
            <label class="absolute text-[14px] secondary-red-text">{{ literalService.get('login.expiredPassword.timeLimit', true) }}</label>
          </div>
        } @else {
          <div class="flex justify-end">
            <label class="absolute text-[14px] cursor-pointer primary-purple-text">{{ literalService.get('login.expiresIn', true) }}: {{ timer }}</label>
          </div>
        }
        <div class="mt-[30px]">
            <label class="text-sm neutrals-grey-05-text">{{ literalService.get('users.actions.changePassword.passwordRequirements.text', true) }}</label>
            <ul class="list-disc mb-4 pl-[1.2rem] mt-2">
                <li class="text-sm neutrals-grey-05-text leading-6">{{ literalService.get('users.actions.changePassword.passwordRequirements.length', true) }}</li>
                <li class="text-sm neutrals-grey-05-text leading-6">{{ literalService.get('users.actions.changePassword.passwordRequirements.characters', true) }}</li>
                <li class="text-sm neutrals-grey-05-text leading-6">{{ literalService.get('users.actions.changePassword.passwordRequirements.noNameNoEmail', true) }}</li>
                <li class="text-sm neutrals-grey-05-text leading-6">{{ literalService.get('users.actions.changePassword.passwordRequirements.noPrevious', true) }}</li>
            </ul>
        </div>
        <button type="submit" [disabled]="timer === TIME_FINISHED && changingPassword || disableChangingPassword" class="primary cursor-pointer text-white font-semibold uppercase w-96 h-14 mt-[56px]">
          @if (changingPassword) {
            <ng-lottie [options]="loadingLogin" (animationCreated)="utilsService.animationCreated($event, 1.5)" />
          } @else {
            {{ timer === TIME_FINISHED ? literalService.get('login.expiredPassword.tryAgain', true) : literalService.get('login.expiredPassword.updatePassword', true) }}
          }
        </button>
      </form>
    } @else {
      <label class="font-bold text-[40px] mt-5 text-center">{{ literalService.get('login.verifyYourIdentity', true) }}</label>
      <label class="font-normal text-[16px] mt-2 text-center w-96">{{ literalService.get('login.verifyYourIdentityText', true) }}</label>
      <form #form novalidate (ngSubmit)="attempts < MAX_ATTEMPTS && timer !== TIME_FINISHED ? verifyCode() : onSubmit(true)" class="mt-8">
        <div class="relative mt-2">
          <div class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
            <img alt="code" [src]="images.login.code" class="w-6" [ngClass]="{'disabled': attempts == MAX_ATTEMPTS || timer === TIME_FINISHED || doingLogin}" />
          </div>
          <input type="text" id="code" autofocus [placeholder]="literalService.get('login.insertYourCode', true)" [(ngModel)]="code" [ngModelOptions]="{standalone: true}" class="block pl-12 w-96 h-12 px-3 py-2 bg-white border rounded-s rounded-e text-sm placeholder-slate-400 focus:outline-none" [ngClass]="{'invalid': errorVerifyingCode}" (keyup)="errorVerifyingCode = false" [disabled]="attempts == MAX_ATTEMPTS || timer === TIME_FINISHED || doingLogin"/>
        </div>
        <div class="flex items-center mb-[21.5px] mt-[9.5px]">
          <input type="checkbox" id="remember_me" [(ngModel)]="rememberMe" [ngModelOptions]="{standalone: true}" [disabled]="verifyingCode || doingLogin" />
          <label for="remember_me" class="ml-2 font-normal text-base cursor-pointer">
            {{ literalService.get('login.rememberMe', true) }} 
          </label>
        </div>
        @if (attempts < MAX_ATTEMPTS && timer !== TIME_FINISHED) {
          <button type="submit" [disabled]="verifyingCode || code.length !== CODE_LENGTH" class="primary cursor-pointer text-white font-semibold uppercase w-96 h-14">
            @if (verifyingCode || doingLogin) {
              <ng-lottie [options]="loadingLogin" (animationCreated)="utilsService.animationCreated($event, 1.5)" />
            } @else {
              {{ literalService.get('login.verify', true) }}
            }
          </button>
        }
        @if (attempts == MAX_ATTEMPTS || timer === TIME_FINISHED) {
          <button type="submit" class="primary cursor-pointer text-white font-semibold uppercase w-96 h-14">
            @if (doingLogin) {
              <ng-lottie [options]="loadingLogin" (animationCreated)="utilsService.animationCreated($event, 1.5)" />
            } @else {
              {{ literalService.get('login.generateNewCode', true) }}
            }
          </button>
        }
      </form>
      <div class="mt-2 w-96">
        <div class="flex items-center" [ngClass]="{'justify-center': attempts == MAX_ATTEMPTS || timer === TIME_FINISHED, 'justify-between': attempts < MAX_ATTEMPTS && timer !== TIME_FINISHED}">
          @if (attempts == MAX_ATTEMPTS) {
            <label class="text-[14px] secondary-red-text">{{ literalService.get('login.attemptsLimit', true) }}</label>
          }
          @else if (timer === TIME_FINISHED) {
            <label class="text-[14px] secondary-red-text">{{ literalService.get('login.timeLimit', true) }}</label>
          }
          @else {
            <div>
              <label class="text-[14px] cursor-pointer primary-purple-text">{{ literalService.get('login.expiresIn', true) }}: {{ timer }}</label>
            </div>
            <div>
              <label class="font-normal text-[14px] primary-purple-text">{{ literalService.get('login.codeNotRecived', true) }}</label>
              <label class="font-bold text-[14px] cursor-pointer primary-purple-text" (click)="onSubmit(true)"> {{ literalService.get('login.resendButton', true) }}</label>
            </div>
          }
        </div>  
        <div class="flex items-center justify-center mt-20 cursor-pointer" (click)="ephemeralToken = ''; clearTimer()">
          <img alt="back" [src]="images.login.back" class="w-4 mr-1" />
          <label class="font-normal text-[16px] text-center cursor-pointer neutrals-grey-05-text">{{ literalService.get('login.backToLogin', true) }}</label>
        </div>
      </div>
    }
  </div>
</div>
